import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { CurrencyField } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';
import { isNotBlank } from '@roc/feature-utils';

interface HoaFormContentProps {
  open: boolean;
}

export const HoaEditModal = observer(({ open }: HoaFormContentProps) => {
  const { docReviewStoreV2 } = useStore();
  const { hoaFormStore } = docReviewStoreV2;

  useEffect(() => {
    if (open) hoaFormStore.load(docReviewStoreV2.docReviewData);
  }, [open]);

  const handleChange = (field: string, value: any) => {
    hoaFormStore.onFieldChange(field, value);
  };

  const f = hoaFormStore.form.fields;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CurrencyField
          label="Annual HOA Fee Amount"
          value={f.annualFeeAmount.value}
          onChange={(_name, value) => handleChange('annualFeeAmount', value)}
          name="annualFeeAmount"
          testId="annualFeeAmount"
          variant="outlined"
          fullWidth
          standaloneLabel
          required
          error={isNotBlank(f.annualFeeAmount.error)}
          errorText={f.annualFeeAmount.error}
        />
      </Grid>
    </Grid>
  );
});
